(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["content-image"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener(
      'load',
      (event) => {
        const img = event.target;
        if (!(img instanceof HTMLImageElement)) return;
        if (!img.classList.contains('custom-image-content__img')) return;
        const box = img.closest('.custom-image-content');
        if (box) box.classList.add('is-loaded');
      },
      true
    );

    const revealIfComplete = (img) => {
      if (img.complete && img.naturalWidth > 0) {
        const box = img.closest('.custom-image-content');
        if (box) box.classList.add('is-loaded');
      }
    };

    const hydrateDeferred = (img) => {
      const srcset = img.getAttribute('data-srcset');
      const src = img.getAttribute('data-src');
      if (!src && !srcset) return;
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (src) {
        img.loading = 'eager';
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
      revealIfComplete(img);
    };

    const deferImgs = document.querySelectorAll('.custom-image-content__img[data-src]');
    const designMode = window.Shopify && Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      deferImgs.forEach(hydrateDeferred);
    } else {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            hydrateDeferred(entry.target);
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '400px 0px', threshold: 0.01 }
      );
      deferImgs.forEach((img) => io.observe(img));
    }

    document.querySelectorAll('.custom-image-content__img').forEach(revealIfComplete);

    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('.custom-image-content__img[data-src]').forEach(hydrateDeferred);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
